import React from 'react';
import { IconProps } from '.';

const SvgAdFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m8.516 9.792.888 2.705H7.588l.879-2.705h.049ZM15.117 9.46c1.338 0 2.041.693 2.041 2.266 0 1.582-.703 2.285-2.05 2.285h-.967V9.46h.976Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M20 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16ZM7.549 8.2l-2.451 7.07H6.68l.537-1.63h2.558l.528 1.63h1.572L9.434 8.2H7.549Zm5.127 0v7.07h2.49c2.158 0 3.457-1.328 3.457-3.544 0-2.198-1.299-3.526-3.428-3.526h-2.52Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgAdFillRounded;
